var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":_vm.el.id}},[(_vm.customMode)?[(_vm.el.type === 'input' || _vm.el.type === 'custinput')?_c('form',{directives:[{name:"drag",rawName:"v-drag"}],staticClass:"drag-item cursor",style:({
        transformOrigin: 'top left',
        transform: `scale(${_vm.el.scale})`,
        boderColor: `${_vm.color}`,
        position: 'absolute',
        width: `${_vm.el.width}px`,
        top: `${_vm.el.top}px`,
        left: `${_vm.el.left}px`,
        zIndex: 1,
        '--current-outline': `${_vm.color}`,
      }),on:{"v-drag-end":_vm.onDragEnd,"click":_vm.onFocus}},[(_vm.el.required)?_c('div',{staticStyle:{"color":"red","height":"26px","font-size":"22px","position":"absolute","left":"-12px","top":"0"}},[_vm._v("\n        *\n      ")]):_vm._e(),_vm._v(" "),_c('input',{staticClass:"cs-input",style:({
          fontFamily: `'${_vm.el.font}', sans-serif`,
          outlineColor: `${_vm.color}`,
          textAlign: _vm.el.font === 'arialunicode' ? 'right' : 'left',
          color: `${_vm.color}`,
          fontSize: `${_vm.el.size}`,
          backgroundColor: 'white',
        }),attrs:{"placeholder":_vm.parsed_name}}),_vm._v(" "),_c('button',{staticClass:"cursor p-close",on:{"click":function($event){$event.preventDefault();return _vm.onRemove.apply(null, arguments)}}},[_vm._v("X")])]):_c('span',{directives:[{name:"drag",rawName:"v-drag"}],staticClass:"drag-item cursor",style:({
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '3px',
        transformOrigin: 'top left',
        transform: `scale(${_vm.el.scale})`,
        border: `2px solid ${_vm.color}`,
        position: 'absolute',
        width: `${_vm.el.width}px`,
        textAlign: _vm.el.font === 'arialunicode' ? 'right' : 'left',
        top: `${_vm.el.top}px`,
        left: `${_vm.el.left}px`,
        zIndex: 1,
      }),on:{"v-drag-end":_vm.onDragEnd,"click":_vm.onFocus}},[(_vm.el.required)?_c('div',{staticStyle:{"color":"red","height":"26px","font-size":"22px","position":"absolute","left":"-12px","top":"0"}},[_vm._v("\n        *\n      ")]):_vm._e(),_vm._v(" "),_c('span',{style:({
          fontSize: `${_vm.el.size}`,
          fontFamily: `'${_vm.el.font}', sans-serif`,
          color: `${_vm.color}`,
        })},[_vm._v(_vm._s(_vm.parsed_value))]),_vm._v(" "),_c('button',{staticClass:"cursor p-close",on:{"click":function($event){$event.preventDefault();return _vm.onRemove.apply(null, arguments)}}},[_vm._v("X")])])]:[(_vm.el.type === 'input')?_c('form',{staticClass:"input-def",style:({
        '--current-outline': `${_vm.color}`,
        transformOrigin: 'top left',
        transform: `scale(${_vm.el.scale})`,
        width: `${_vm.el.auto_expand ?  `auto` : `${_vm.el.width}px`}`,
        boder: 'none',
        position: 'absolute',

        top: `${_vm.el.top}px`,
        left: `${_vm.el.left}px`,
        zIndex: 1,
      })},[(_vm.el.required)?_c('div',{staticStyle:{"color":"red","height":"26px","font-size":"22px","position":"absolute","left":"-12px","top":"0"}},[_vm._v("\n        *\n      ")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.el.value),expression:"el.value"}],staticClass:"cs-input",style:({
          fontFamily: `'${_vm.el.font}', sans-serif`,
          outlineColor: `${_vm.color}`,
          color: `${_vm.color}`,
          textAlign: _vm.el.font === 'arialunicode' ? 'right' : 'left',
          fontSize: `${_vm.el.size}`,
          backgroundColor: 'whiter',
        }),attrs:{"placeholder":_vm.el.name},domProps:{"value":(_vm.el.value)},on:{"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.el, "value", $event.target.value)},_vm.inputted]}})]):_c('span',{staticClass:"input-def",style:(`position: absolute;transform: scale(${_vm.el.scale});font-size:${
        _vm.el.size
      };transform-origin: top left; top:calc(${_vm.el.top}px + 16px - ${_vm.el.size}px); left:${_vm.el.left};width: ${_vm.el.auto_expand ?  `auto` : `${_vm.el.width}px`}; z-index: 1;text-align: ${_vm.el.font === 'arialunicode' ? 'right' : 'left'}`)},[(_vm.el.required)?_c('div',{staticStyle:{"color":"red","height":"26px","font-size":"22px","position":"absolute","left":"-12px","top":"0"}},[_vm._v("\n        *\n      ")]):_vm._e(),_vm._v(" "),_c('span',{style:({
          fontFamily: `'${_vm.el.font}', sans-serif`,
          fontSize: `${_vm.el.size}`,
          color: `${_vm.color}`,
        })},[_vm._v(_vm._s(_vm.el.value))])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }